import MainLayout from '@/common/components/layouts/MainLayout';
import InformationDamagedList from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/damageList/InformationDamagedList';
import ImagesDamagedList from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/damageList/ImagesDamagedList';

const DamagedListPage = ({ state }: { state: 'information' | 'images' }) => (
  <MainLayout
    title={state === 'images' ? 'تصاویر زیان‌دیده' : 'مشخصات زیان‌دیده'}
    header="titleHeader"
  >
    {state === 'images' ? <ImagesDamagedList /> : <InformationDamagedList />}
  </MainLayout>
);
export default DamagedListPage;
